import { render, staticRenderFns } from "./editRegistration.vue?vue&type=template&id=f98f52d6&scoped=true"
import script from "./editRegistration.vue?vue&type=script&lang=js"
export * from "./editRegistration.vue?vue&type=script&lang=js"
import style0 from "./editRegistration.vue?vue&type=style&index=0&id=f98f52d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98f52d6",
  null
  
)

export default component.exports